import { render, staticRenderFns } from "./singleAdd.vue?vue&type=template&id=f223e058&scoped=true"
import script from "./singleAdd.vue?vue&type=script&lang=js"
export * from "./singleAdd.vue?vue&type=script&lang=js"
import style0 from "./singleAdd.vue?vue&type=style&index=0&id=f223e058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f223e058",
  null
  
)

export default component.exports